var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"CreateMyAccount--Container",attrs:{"fluid":""}},[_c('v-row',{staticClass:"my-14",attrs:{"justify":"center"}},[_c('v-btn',{staticClass:"white--text",attrs:{"to":"/login","color":"#37A3C6","tile":"","x-large":""}},[_c('span',[_vm._v(" "+_vm._s(_vm.$t("App.ProfessionalSpace.CreateMyAccount.SignUp"))+" ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }